import { render } from "./Intergral.vue?vue&type=template&id=70e96b46&scoped=true"
import script from "./Intergral.vue?vue&type=script&lang=ts"
export * from "./Intergral.vue?vue&type=script&lang=ts"

import "./Intergral.vue?vue&type=style&index=0&id=70e96b46&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70e96b46"

export default script